import {
    GlobalLoading
} from '../constants';

const initialState = {  
    showLoading: false,
    latestProcessStatus: false, 
};

export default (state, action) => {
    state = state || initialState;

    if (action.type === GlobalLoading) {
        return {
            ...state,
            showLoading: action.showLoading,
            latestProcessStatus: action.latestProcessStatus
        };
    }

    return state;
};
